import loadable from '@loadable/component';

const ProductMediaLightboxLoader = loadable(
  () => import(/* webpackChunkName: "extra" */ './product-media-lightbox')
);

export default ProductMediaLightboxLoader;
